Vue.component("DownloadHotspot", {
    props: ["hotspot", "index", "settings", "resetHotspot", "activeHotspot"],
    template: `
        <transition :name="hotspotEntranceType">
            <div class="DownloadHotspot hotspot" :style="[{left: hotspot.x + 'px', top: hotspot.y + 'px'}]" @click="goto(hotspot)" >
                <transition enter-active-class="animated flipInX"
                    leave-active-class="animated flipOutX">
                    <div class="hotspot__title_wrapper" >
                        <h2 v-html="hotspot.title"></h2>
                    </div>
                </transition>
            </div>
        </transition>
    `,
    methods: {
        goto(hotspot) {
            // Call goto() in PageScene
            this.$emit("goto", hotspot)
        },
    }
})